import loadable from '@loadable/component'

export default {
    '/:type/activity/2023-new-user': loadable(() => import('./Home')),
    '/:type/activity/2024-new-user': loadable(() => import('./Home')),
}
